// 業務報告書
$(() => {
    if (document.getElementById('agent-report-form') != null) {
        $('.modal-exec').click(function(){
            $('#approval_comment').val($('#modal_approval_comment').val());
            $('#approval').submit();
        });

        $('.submission-exec').click(function(){
            $('#submission_comment').val($('#modal_submission_comment').val());
            $('#submission').submit();
        });

        $('.remand-exec').click(function(){
            $('#remand_comment').val($('#modal_remand_comment').val());
            $('#remand').submit();
        });

        $('.reapplication-exec').click(function(){
            $('#reapplication').submit();
        });

        $('.forcibly-exec').click(function(){
            $('#forcibly').submit();
        });

        $('#js-regist-report').click(function(){
            $('#regist').submit();
        });
    }
    showResubmissionPartnerReportModal();
});

// PTN業務報告書が再提出されている場合にモーダル表示
function showResubmissionPartnerReportModal()
{
    if (document.getElementById('resubmission_partner_report_modal') != null) {
        $('#resubmission_partner_report_modal').modal('show');
    }
}